import { NotificationStore } from './models';

export const defaultState: NotificationStore = {
  sdos: [],
  showCustomNotificationList: false,
};

export const namespace = 'notifications';
